import React, {Component, ReactElement, ReactNode} from 'react'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import NatCondominiumAuthoritySettingRepo from './repository/NatCondominiumAuthoritySettingRepo'
import {
    AuthorityInfo,
    FunctionDivAuthorityInfo,
    NatGetCondominiumAuthoritySetting,
    RoleAuthorityInfo,
    UseWebsite,
} from './repository/NatGetCondominiumAuthoritySetting'
import {
    CondominiumAuthoritySettingInfo,
    NatPutCondominiumAuthoritySetting,
    NatPutCondominiumAuthoritySettingParams,
} from './repository/NatPutCondominiumAuthoritySetting'
import {Nullable} from '../../../app/TypeHelpers'
import {Messages} from '../../../Messages'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {TableCellProps} from '@mui/material/TableCell'
import {
    ASSOC_GROUP,
    AVAILABLE_SITE,
    MESSAGE_TYPE,
    ROLE_FOR_ADMINISTRATOR,
    ROLE_FOR_ADMINISTRATOR_REAL,
    ROLE_FOR_RESIDENT_REAL,
    VALID_OR_NOT_CHECK,
} from '../../../CodeMaster'
import styled from 'styled-components'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink} from '../../../styledComponents/adminPage/Links'
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import {Sticky, StickyContainer} from 'react-sticky'
import {ConditionTableFixed} from '../../../styledComponents/adminPage/ConditionTable'
import {
    AUTHORITY_APPLICATION_PRINT_APPLICATION,
    AUTHORITY_APPROVAL_APPLICATION,
    AUTHORITY_APPROVAL_DELEGATE_APPLICATION,
    AUTHORITY_CANCEL_RESERVATION,
    AUTHORITY_CONTRIBUTE,
    AUTHORITY_EDIT,
    AUTHORITY_EDIT_MEETING_ASSOC_DIRECTOR,
    AUTHORITY_MANAGE_ATTENDANCE_ASSOC_DIRECTOR,
    AUTHORITY_POST_COMMENT,
    AUTHORITY_RECEPTION_APPLICATION,
    AUTHORITY_VIEW,
    AUTHORITY_VIEW_COMPLETE_ONLY,
    AUTHORITY_VIEW_MEETING_ASSOC_DIRECTOR,
    AUTHORITY_DELETE_COMMENT,
    AUTHORITY_DELETE_TOPIC,
    FUNCTION_DIV_ID_CLOSED_SETTING,
    FUNCTION_DIV_ID_FACILITY_DESCRIPTION,
    FUNCTION_DIV_ID_FACILITY_SETTING,
    NON_EDIT_AUTHORITY_FOR_ADMIN,
    NON_EDIT_AUTHORITY_FOR_RESIDENT,
    AUTHORITY_REGISTER_TOPIC,
} from './NatAdminCondominiumAuthorityConstant'
import {Location} from 'react-router-dom'

import {Box, TableBody, TableCell, TableRow} from '@mui/material'

interface LocationState {
    initialMessage: HeadingAreaMessageParams
}

interface Props {
    condominiumCd: string
    condominiumAuthoritySettingRepo: NatCondominiumAuthoritySettingRepo
    eventEmitter: EventEmitterExAdmin
    location: Location<LocationState>
}

interface States {
    adminAuthoritySetting: UseWebsite
    residentAuthoritySetting: UseWebsite
    isLoadCompleted: boolean
    nonEditAuthorityByAdmin: Map<ROLE_FOR_ADMINISTRATOR_REAL, Map<number, number[] | 'all'>>
    nonEditAuthorityByResident: Map<ROLE_FOR_RESIDENT_REAL, Map<number, number[] | 'all'>>
    adminRoleInfos: RoleInfo[]
    residentRoleInfos: RoleInfo[]
}

interface RoleInfo {
    role: ROLE_FOR_ADMINISTRATOR_REAL | ROLE_FOR_RESIDENT_REAL
    group: Nullable<ASSOC_GROUP[]>
}

class NatAdminCondominiumAuthoritySettingPage extends Component<Props & AdminPagePropsSet, States> {
    // 初期表示時の物件権限設定　保持
    originAdminAuthoritySetting: UseWebsite
    originResidentAuthoritySetting: UseWebsite

    constructor(props: Props & AdminPagePropsSet) {
        super(props)
        this.state = {
            adminAuthoritySetting: {
                useWebsite: '',
                functionDivAuthorityInfo: [],
            },
            residentAuthoritySetting: {
                useWebsite: '',
                functionDivAuthorityInfo: [],
            },
            isLoadCompleted: false,
            nonEditAuthorityByAdmin: NON_EDIT_AUTHORITY_FOR_ADMIN,
            nonEditAuthorityByResident: NON_EDIT_AUTHORITY_FOR_RESIDENT,
            adminRoleInfos: ROLE_FOR_ADMINISTRATOR_REAL.values()
                .filter(role => role !== ROLE_FOR_ADMINISTRATOR_REAL.SYSTEM_ADMIN &&
                    role !== ROLE_FOR_ADMINISTRATOR_REAL.ASSOC_CHAIRMAN &&
                    role !== ROLE_FOR_ADMINISTRATOR_REAL.ASSOC_VICE_CHAIRMAN &&
                    role !== ROLE_FOR_ADMINISTRATOR_REAL.OFFICE_CENTER_OWNERSHIP_TRANSFER)
                .map(role => {
                    if (role.value === ROLE_FOR_ADMINISTRATOR_REAL.ASSOC.value) {
                        return ({role: role, group: ASSOC_GROUP.values()})
                    }
                    return ({role: role, group: null})
                }),
            residentRoleInfos: ROLE_FOR_RESIDENT_REAL.values()
                .filter(role => role !== ROLE_FOR_RESIDENT_REAL.BEFORE_OCCUPANCY)
                .map(role => {
                    return ({role: role, group: null})
                }),
        }

        this.originAdminAuthoritySetting = {
            useWebsite: '',
            functionDivAuthorityInfo: [],
        }
        this.originResidentAuthoritySetting = {
            useWebsite: '',
            functionDivAuthorityInfo: [],
        }
        this.updateAuthoritySettingClick = this.updateAuthoritySettingClick.bind(this)
        this.judgeAuthoritySetting = this.judgeAuthoritySetting.bind(this)
        this.cancelLinkClick = this.cancelLinkClick.bind(this)
        this.registerAuthoritySettingButton = this.registerAuthoritySettingButton.bind(this)
        this.handleRegisterCancelClick = this.handleRegisterCancelClick.bind(this)
        this.handleRegisterOkClick = this.handleRegisterOkClick.bind(this)
        this.handleRegisterCancelClick = this.handleRegisterCancelClick.bind(this)
        this.handleRegisterOkClick = this.handleRegisterOkClick.bind(this)
    }

    async componentDidMount(): Promise<void> {
        try {
            // 権限設定取得
            await this.getCondominiumAuthoritySetting()
        } finally {
        }
        this.showInitialMessage()
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    async getCondominiumAuthoritySetting(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const retCondominiumAuthoritySetting: Nullable<NatGetCondominiumAuthoritySetting> =
                await this.props.asyncCallFunction(
                    this.props.condominiumAuthoritySettingRepo.getCondominiumAuthoritySetting.bind(
                        this.props.condominiumAuthoritySettingRepo, this.props.condominiumCd),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )

            let adminAuthoritySetting: UseWebsite = {
                useWebsite: '',
                functionDivAuthorityInfo: [],
            }
            let residentAuthoritySetting: UseWebsite = {
                useWebsite: '',
                functionDivAuthorityInfo: [],
            }

            const sortOrderForAdministrator: string[] = ROLE_FOR_ADMINISTRATOR.values()
                .flatMap(role => {
                    if (role.value === ROLE_FOR_ADMINISTRATOR.ASSOC.value) {
                        return [...ASSOC_GROUP.values().map(assocRole => assocRole.value)]
                    }
                    return role.value
                })

            if (retCondominiumAuthoritySetting && retCondominiumAuthoritySetting.details) {
                retCondominiumAuthoritySetting.details.websiteFunctionDivAutorityInfo.forEach(
                    (websiteFunctionDivAutority) => {
                        // 管理者権限、居住者権限とで分ける
                        if (websiteFunctionDivAutority.useWebsite === AVAILABLE_SITE.ADMIN.value) {
                            // システム運用スタッフと事務センター（重調担当）は、除外する
                            adminAuthoritySetting = {
                                useWebsite: websiteFunctionDivAutority.useWebsite,
                                functionDivAuthorityInfo: this.exclusionTargetRoll(
                                    websiteFunctionDivAutority,
                                    [
                                        ROLE_FOR_ADMINISTRATOR.SYSTEM_ADMIN,
                                        ROLE_FOR_ADMINISTRATOR.OFFICE_CENTER_OWNERSHIP_TRANSFER,
                                    ],
                                ),
                            }
                            adminAuthoritySetting.functionDivAuthorityInfo
                                .forEach(functionDivAuthorityInfo => functionDivAuthorityInfo.authorityInfo
                                    .forEach(authorityInfo => authorityInfo.roleAuthorityInfo
                                        .sort((e1, e2) => sortOrderForAdministrator.indexOf(e1.roleId)
                                            - sortOrderForAdministrator.indexOf(e2.roleId))))
                        } else {
                            // 入居前は、除外する
                            residentAuthoritySetting = {
                                useWebsite: websiteFunctionDivAutority.useWebsite,
                                functionDivAuthorityInfo: this.exclusionTargetRoll(
                                    websiteFunctionDivAutority,
                                    [ROLE_FOR_RESIDENT_REAL.BEFORE_OCCUPANCY],
                                ),
                            }
                        }
                    })
                // 初期表示時の権限情報を設定
                this.originAdminAuthoritySetting =
                    JSON.parse(JSON.stringify(adminAuthoritySetting))
                this.originResidentAuthoritySetting =
                    JSON.parse(JSON.stringify(residentAuthoritySetting))
            }

            this.setState({
                adminAuthoritySetting: adminAuthoritySetting,
                residentAuthoritySetting: residentAuthoritySetting,
                isLoadCompleted: true,
            })
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    exclusionTargetRoll(
        websiteFunctionDivAuthority: UseWebsite,
        exclusionRoles: (ROLE_FOR_ADMINISTRATOR | ROLE_FOR_RESIDENT_REAL)[],
    ): FunctionDivAuthorityInfo[] {
        const functionDivAuthorityInfo: FunctionDivAuthorityInfo[] = []
        const exclusionRoleValues = exclusionRoles.map((role) => role.value)
        websiteFunctionDivAuthority.functionDivAuthorityInfo.map((functionDivAuthority) => {
            const authorityInfo: AuthorityInfo[] = []
            functionDivAuthority.authorityInfo.map((authority) => {
                const roleAuthorityInfo: RoleAuthorityInfo[] = []
                authority.roleAuthorityInfo.map((role) => {
                    if (!exclusionRoleValues.includes(role.roleId)) {
                        roleAuthorityInfo.push(role)
                    }
                })
                authorityInfo.push({
                    authority: authority.authority,
                    authorityName: authority.authorityName,
                    roleAuthorityInfo,
                })
            })
            functionDivAuthorityInfo.push({
                functionDivId: functionDivAuthority.functionDivId,
                functionDivName: functionDivAuthority.functionDivName,
                authorityInfo: authorityInfo,
            })
        })
        return functionDivAuthorityInfo
    }

    renderAuthoritySettingTable(authoritySetting: UseWebsite): Nullable<ReactElement> {
        const {adminRoleInfos, residentRoleInfos} = this.state

        const useWebsite = authoritySetting.useWebsite
        const roleInfos = useWebsite === AVAILABLE_SITE.ADMIN.value ?
            adminRoleInfos : residentRoleInfos

        let roleLength: number = 0
        roleInfos.forEach((roleInfo) => {
            roleInfo.group ?
                roleLength = roleLength + roleInfo.group.length :
                roleLength = roleLength + 1
        })

        const header =
            <>
                <FlexTableHeaderNotGrowItem style={{width: '30%'}}>
                    {(useWebsite === AVAILABLE_SITE.ADMIN.value) ?
                        '管理者権限' : '居住者権限'}
                </FlexTableHeaderNotGrowItem>
                {roleInfos.map((roleInfo, index) =>
                    !roleInfo.group ?
                        <FlexTableHeaderItem
                            key={index}
                            style={{width: `calc((100% - 30%)/${roleLength})`}}>
                            {roleInfo.role.label}
                        </FlexTableHeaderItem> :
                        <FlexTableHeaderNotGrowItem
                            key={index}
                            style={{width: `calc((100% - 30%)/${roleLength} * ${roleInfo.group.length} * 0.725)`}}>
                            <Box style={{textAlign: `left`}} pl={'20px'} pb={'20px'}>
                                {roleInfo.role.label}
                            </Box>
                            <Box display={'flex'}>
                                {roleInfo.group.map((group, groupIndex) => {
                                    const groupLength = roleInfo.group?.length ?? 0
                                    return (
                                        <Box key={groupIndex} style={{flexBasis: `calc(100%/${groupLength})`}}>
                                            {group.label}
                                        </Box>
                                    )
                                })}
                            </Box>
                        </FlexTableHeaderNotGrowItem>,
                )}
            </>

        return (
            <>
                <StickyContainer>
                    <Sticky>
                        {({style}) =>
                            <FlexTableHeaderContainer style={style}>
                                {header}
                            </FlexTableHeaderContainer>
                        }
                    </Sticky>
                    <ConditionTableFixed>
                        <colgroup>
                            <col width={'18%'}/>
                            <col width={'12%'}/>
                            {roleInfos.map((roleInfo, roleInfoIndex) =>
                                !roleInfo.group ?
                                    <col key={roleInfoIndex} width={`auto`}/> :
                                    roleInfo.group.map((group, groupIndex) =>
                                        <col key={groupIndex}
                                             style={{width: `calc((100% - 30%)/${roleLength} * 0.725)`}}/>,
                                    ),
                            )}
                        </colgroup>
                        <TableBody>
                            {
                                authoritySetting.functionDivAuthorityInfo.map(
                                    (functionDivAuthority, functionDivAuthorityIndex) => (
                                        <React.Fragment key={`functionDivAuthority_ ${functionDivAuthorityIndex}`}>
                                            {
                                                functionDivAuthority.authorityInfo.map((authority, index) => (
                                                    <React.Fragment key={`authority_${index}`}>
                                                        {this.renderCell(
                                                            useWebsite,
                                                            functionDivAuthority,
                                                            functionDivAuthorityIndex,
                                                            authority,
                                                            index)}
                                                    </React.Fragment>
                                                ))
                                            }
                                        </React.Fragment>
                                    ))
                            }
                        </TableBody>
                    </ConditionTableFixed>
                </StickyContainer>
            </>
        )

        return null
    }

    renderCell(
        useWebsite: string,
        functionDivAuthority: FunctionDivAuthorityInfo,
        functionDivAuthorityIndex: number,
        authorityInfo: AuthorityInfo,
        index: number,
    ): Nullable<ReactElement> {
        const {nonEditAuthorityByAdmin, nonEditAuthorityByResident} = this.state

        const functionDivId = Number(functionDivAuthority.functionDivId)
        const authorityId = Number(authorityInfo.authority)

        return (
            <TableRow>
                {index === 0 &&
                    <TableCell align={'left'}
                               rowSpan={functionDivAuthority.authorityInfo.length}>
                        {functionDivAuthority.functionDivName}
                    </TableCell>
                }
                <TableCell align={'left'} key={index}>
                    {authorityInfo.authorityName}
                </TableCell>
                {authorityInfo.roleAuthorityInfo.map((authority, roleAuthorityIndex) => {
                    const roleIdMaster = useWebsite === AVAILABLE_SITE.ADMIN.value ?
                        ROLE_FOR_ADMINISTRATOR_REAL.codeToEnumConstants(authority.roleId) :
                        ROLE_FOR_RESIDENT_REAL.codeToEnumConstants(authority.roleId)
                    const nonEditAuthorityInfo = useWebsite === AVAILABLE_SITE.ADMIN.value ?
                        nonEditAuthorityByAdmin : nonEditAuthorityByResident

                    const nonEditAuthority = nonEditAuthorityInfo.get(roleIdMaster)?.get(functionDivId)
                    const isEditable = !(nonEditAuthority !== undefined &&
                        (nonEditAuthority === 'all' ||
                            nonEditAuthority.includes(authorityId)))

                    if (isEditable) {
                        return (
                            <StyledTableCell align={'center'}
                                             key={`roleAuthorityInfo_${roleAuthorityIndex}`}
                                             changeFlg={this.judgeAuthoritySetting(
                                                 useWebsite,
                                                 functionDivAuthorityIndex,
                                                 index,
                                                 roleAuthorityIndex)}
                                             onClick={() => this.updateAuthoritySettingClick(
                                                 useWebsite,
                                                 functionDivAuthorityIndex,
                                                 index,
                                                 roleAuthorityIndex)}>
                                {(authority.validFlag === VALID_OR_NOT_CHECK.NOT.value) ?
                                    VALID_OR_NOT_CHECK.NOT.label :
                                    VALID_OR_NOT_CHECK.VALID.label}
                            </StyledTableCell>
                        )
                    } else {
                        return <NonEditTableCell key={`roleAuthorityInfo_${roleAuthorityIndex}`}/>
                    }
                })
                }
            </TableRow>
        )
    }

    // 有効/無効　更新
    updateAuthoritySettingClick(
        useWebsite: string,
        functionDivAuthorityIndex: number,
        authorityIndex: number,
        roleAuthorityIndex: number): void {

        let authoritySetting: UseWebsite
        if (useWebsite === AVAILABLE_SITE.ADMIN.value) {
            // 管理者権限
            authoritySetting = this.state.adminAuthoritySetting
        } else {
            // 居住者権限
            authoritySetting = this.state.residentAuthoritySetting
        }

        const functionDivAuthorityInfo: FunctionDivAuthorityInfo =
            authoritySetting.functionDivAuthorityInfo[functionDivAuthorityIndex]
        const authorityInfo: AuthorityInfo = functionDivAuthorityInfo.authorityInfo[authorityIndex]
        const roleAuthorityInfo: RoleAuthorityInfo = authorityInfo.roleAuthorityInfo[roleAuthorityIndex]

        if (!roleAuthorityInfo) {
            return
        }
        // 現在の有効フラグ
        const validFlag: string = roleAuthorityInfo.validFlag
        let setValidFlag: string

        // 有効→無効（無効→有効）
        if (validFlag === VALID_OR_NOT_CHECK.NOT.value) {
            setValidFlag = VALID_OR_NOT_CHECK.VALID.value
        } else {
            setValidFlag = VALID_OR_NOT_CHECK.NOT.value
        }
        roleAuthorityInfo.validFlag = setValidFlag

        // 変更対象の機能権限
        const targetAuthority: number = Number(authorityInfo.authority)

        // 変更対象が"編集"または"編集（投稿）"の場合
        if (targetAuthority === AUTHORITY_EDIT ||
            targetAuthority === AUTHORITY_CONTRIBUTE) {
            functionDivAuthorityInfo.authorityInfo.some((functionDivAuthority, key) => {
                if (Number(functionDivAuthority.authority) === AUTHORITY_VIEW) {
                    // 現在の参照権限を取得
                    const linkValidFlag: string =
                        functionDivAuthorityInfo.authorityInfo[key].roleAuthorityInfo[roleAuthorityIndex].validFlag
                    // 編集権限が無効の状態
                    if (setValidFlag === VALID_OR_NOT_CHECK.NOT.value) {
                        // 編集権限 = 無効　現在の参照権限の状態に関わらず参照権限に対して操作はしない
                        return true
                    } else {
                        // 編集権限が有効の状態
                        // 編集権限 = 有効　現在の参照権限 = 有効　の場合、参照権限に対して操作はしない
                        if (linkValidFlag === VALID_OR_NOT_CHECK.VALID.value) {
                            return true
                        } else {
                            // 編集権限 = 有効　現在の参照権限 = 無効　の場合、参照権限も連動して有効にする
                            functionDivAuthorityInfo.authorityInfo[key].roleAuthorityInfo
                                [roleAuthorityIndex].validFlag = VALID_OR_NOT_CHECK.VALID.value
                        }
                    }
                }
            })

            // 変更対象が"参照"権限の場合
        } else if (targetAuthority === AUTHORITY_VIEW) {
            functionDivAuthorityInfo.authorityInfo.forEach((functionDivAuthority, key) => {
                if (Number(functionDivAuthority.authority) === AUTHORITY_EDIT ||
                    Number(functionDivAuthority.authority) === AUTHORITY_CONTRIBUTE) {
                    // 現在の編集または"編集（投稿）"を取得
                    const linkValidFlag: string =
                        functionDivAuthorityInfo.authorityInfo[key].roleAuthorityInfo[roleAuthorityIndex].validFlag
                    // 参照権限が無効の状態
                    if (setValidFlag === VALID_OR_NOT_CHECK.NOT.value) {
                        // 参照権限 = 無効　現在の編集権限 = 無効　の場合、編集権限に対して操作はしない
                        if (linkValidFlag === VALID_OR_NOT_CHECK.NOT.value) {
                            return true
                        } else {
                            // 参照権限 = 無効　現在の編集権限 = 有効　の場合、編集権限も連動して無効にする
                            functionDivAuthorityInfo.authorityInfo[key].roleAuthorityInfo
                                [roleAuthorityIndex].validFlag = VALID_OR_NOT_CHECK.NOT.value
                        }
                    } else {
                        // 参照権限が有効の状態、編集権限に対して操作はしない
                        return true
                    }
                }
            })
        }

        // 理事会管理の権限連動制御
        // 変更対象が"会議情報編集"権限または"出欠管理"権限または"コメント投稿"権限の場合
        if (targetAuthority === AUTHORITY_EDIT_MEETING_ASSOC_DIRECTOR
            || targetAuthority === AUTHORITY_MANAGE_ATTENDANCE_ASSOC_DIRECTOR
            || targetAuthority === AUTHORITY_POST_COMMENT) {
            functionDivAuthorityInfo.authorityInfo
                .filter(functionDivAuthority =>
                    Number(functionDivAuthority.authority) === AUTHORITY_VIEW_MEETING_ASSOC_DIRECTOR)
                .forEach(functionDivAuthority => {
                    // 現在の"会議情報参照"権限を取得
                    const linkAuthorityInfo = functionDivAuthority.roleAuthorityInfo[roleAuthorityIndex]
                    // 現在の参照権限が無効で、編集権限を有効にする時には参照権限も連動して有効にする
                    if (setValidFlag === VALID_OR_NOT_CHECK.VALID.value
                        && linkAuthorityInfo.validFlag === VALID_OR_NOT_CHECK.NOT.value) {
                        linkAuthorityInfo.validFlag = VALID_OR_NOT_CHECK.VALID.value
                    }
                })
            // 変更対象が"会議情報参照"権限の場合
        } else if (targetAuthority === AUTHORITY_VIEW_MEETING_ASSOC_DIRECTOR) {
            functionDivAuthorityInfo.authorityInfo
                .filter(functionDivAuthority => {
                    const authorityId = Number(functionDivAuthority.authority)
                    return authorityId === AUTHORITY_EDIT_MEETING_ASSOC_DIRECTOR
                        || authorityId === AUTHORITY_MANAGE_ATTENDANCE_ASSOC_DIRECTOR
                        || authorityId === AUTHORITY_POST_COMMENT
                })
                .forEach(functionDivAuthority => {
                    const linkAuthorityInfo =
                        functionDivAuthority.roleAuthorityInfo[roleAuthorityIndex]
                    // 参照権限を無効にする時には会議情報編集、出欠管理、コメント投稿権限も連動して無効にする
                    if (setValidFlag === VALID_OR_NOT_CHECK.NOT.value) {
                        linkAuthorityInfo.validFlag = VALID_OR_NOT_CHECK.NOT.value
                    }
                })
        }

        // 申請管理の権限連動制御
        // 変更対象が"受付"権限または"承認"権限"または承認操作代行"権限または"申請内容印刷"権限の場合
        if (targetAuthority === AUTHORITY_APPROVAL_APPLICATION
            || targetAuthority === AUTHORITY_RECEPTION_APPLICATION
            || targetAuthority === AUTHORITY_APPROVAL_DELEGATE_APPLICATION
            || targetAuthority === AUTHORITY_APPLICATION_PRINT_APPLICATION) {
            functionDivAuthorityInfo.authorityInfo
                .filter(functionDivAuthority =>
                    Number(functionDivAuthority.authority) === AUTHORITY_VIEW)
                .forEach(functionDivAuthority => {
                    // 現在の"参照"権限を取得
                    const linkAuthorityInfo = functionDivAuthority.roleAuthorityInfo[roleAuthorityIndex]
                    // 現在の参照権限が無効で、編集権限を有効にする時には参照権限も連動して有効にする
                    if (setValidFlag === VALID_OR_NOT_CHECK.VALID.value
                        && linkAuthorityInfo.validFlag === VALID_OR_NOT_CHECK.NOT.value) {
                        linkAuthorityInfo.validFlag = VALID_OR_NOT_CHECK.VALID.value
                    }
                })
            // 変更対象が"参照"権限の場合
        } else if (targetAuthority === AUTHORITY_VIEW) {
            functionDivAuthorityInfo.authorityInfo
                .filter(functionDivAuthority => {
                    const authorityId = Number(functionDivAuthority.authority)
                    return authorityId === AUTHORITY_APPROVAL_APPLICATION
                        || authorityId === AUTHORITY_RECEPTION_APPLICATION
                        || authorityId === AUTHORITY_APPROVAL_DELEGATE_APPLICATION
                        || authorityId === AUTHORITY_APPLICATION_PRINT_APPLICATION
                })
                .forEach(functionDivAuthority => {
                    const linkAuthorityInfo =
                        functionDivAuthority.roleAuthorityInfo[roleAuthorityIndex]
                    // 参照権限を無効にする時には受付、承認、承認操作代行、申請内容印刷権限も連動して無効にする
                    if (setValidFlag === VALID_OR_NOT_CHECK.NOT.value) {
                        linkAuthorityInfo.validFlag = VALID_OR_NOT_CHECK.NOT.value
                    }
                })
        }

        // 組合員資格変更届の権限連動制御
        // 変更対象が"申請内容印刷"権限の場合
        if (targetAuthority === AUTHORITY_APPLICATION_PRINT_APPLICATION) {
            functionDivAuthorityInfo.authorityInfo
                .filter(functionDivAuthority =>
                    Number(functionDivAuthority.authority) === AUTHORITY_VIEW_COMPLETE_ONLY)
                .forEach(functionDivAuthority => {
                    // 現在の"参照（提出後）"権限を取得
                    const linkAuthorityInfo = functionDivAuthority.roleAuthorityInfo[roleAuthorityIndex]
                    // 現在の参照（提出後）権限が無効で、編集権限を有効にする時には参照（提出後）権限も連動して有効にする
                    if (setValidFlag === VALID_OR_NOT_CHECK.VALID.value
                        && linkAuthorityInfo.validFlag === VALID_OR_NOT_CHECK.NOT.value) {
                        linkAuthorityInfo.validFlag = VALID_OR_NOT_CHECK.VALID.value
                    }
                })
            // 変更対象が"参照（提出後）"権限の場合
        } else if (targetAuthority === AUTHORITY_VIEW_COMPLETE_ONLY) {
            functionDivAuthorityInfo.authorityInfo
                .filter(functionDivAuthority => {
                    const authorityId = Number(functionDivAuthority.authority)
                    return authorityId === AUTHORITY_APPLICATION_PRINT_APPLICATION
                })
                .forEach(functionDivAuthority => {
                    const linkAuthorityInfo =
                        functionDivAuthority.roleAuthorityInfo[roleAuthorityIndex]
                    // 参照（提出後）権限を無効にする時には申請内容印刷権限も連動して無効にする
                    if (setValidFlag === VALID_OR_NOT_CHECK.NOT.value) {
                        linkAuthorityInfo.validFlag = VALID_OR_NOT_CHECK.NOT.value
                    }
                })
        }

        // 災害時情報共有管理（管理者）の権限連動制御
        // 変更対象が"コメント投稿"、"コメント削除"、"トピック登録"、"トピック削除"の場合
        if (targetAuthority === AUTHORITY_POST_COMMENT
            || targetAuthority === AUTHORITY_DELETE_COMMENT
            || targetAuthority === AUTHORITY_REGISTER_TOPIC
            || targetAuthority === AUTHORITY_DELETE_TOPIC) {
            functionDivAuthorityInfo.authorityInfo
                .filter(functionDivAuthority =>
                    Number(functionDivAuthority.authority) === AUTHORITY_VIEW)
                .forEach(functionDivAuthority => {
                    // 現在の"参照"権限を取得
                    const linkAuthorityInfo = functionDivAuthority.roleAuthorityInfo[roleAuthorityIndex]
                    // 現在の参照権限が無効で、対象権限を有効にする時には参照権限も連動して有効にする
                    if (setValidFlag === VALID_OR_NOT_CHECK.VALID.value
                        && linkAuthorityInfo.validFlag === VALID_OR_NOT_CHECK.NOT.value) {
                        linkAuthorityInfo.validFlag = VALID_OR_NOT_CHECK.VALID.value
                    }
                })
            // 変更対象が"参照"権限の場合
        } else if (targetAuthority === AUTHORITY_VIEW) {
            functionDivAuthorityInfo.authorityInfo
                .filter(functionDivAuthority => {
                    const authorityId = Number(functionDivAuthority.authority)
                    return authorityId === AUTHORITY_POST_COMMENT
                        || authorityId === AUTHORITY_DELETE_COMMENT
                        || authorityId === AUTHORITY_REGISTER_TOPIC
                        || authorityId === AUTHORITY_DELETE_TOPIC
                })
                .forEach(functionDivAuthority => {
                    const linkAuthorityInfo =
                        functionDivAuthority.roleAuthorityInfo[roleAuthorityIndex]
                    // 参照権限を無効にする時には対象権限も連動して無効にする
                    if (setValidFlag === VALID_OR_NOT_CHECK.NOT.value) {
                        linkAuthorityInfo.validFlag = VALID_OR_NOT_CHECK.NOT.value
                    }
                })
        }

        // 災害時情報共有管理（居住者）の権限連動制御
        // 変更対象が"コメント登録"の場合
        if (targetAuthority === AUTHORITY_POST_COMMENT) {
            functionDivAuthorityInfo.authorityInfo
                .filter(functionDivAuthority =>
                    Number(functionDivAuthority.authority) === AUTHORITY_VIEW)
                .forEach(functionDivAuthority => {
                    // 現在の"参照"権限を取得
                    const linkAuthorityInfo = functionDivAuthority.roleAuthorityInfo[roleAuthorityIndex]
                    // 現在の参照権限が無効で、対象権限を有効にする時には参照権限も連動して有効にする
                    if (setValidFlag === VALID_OR_NOT_CHECK.VALID.value
                        && linkAuthorityInfo.validFlag === VALID_OR_NOT_CHECK.NOT.value) {
                        linkAuthorityInfo.validFlag = VALID_OR_NOT_CHECK.VALID.value
                    }
                })
            // 変更対象が"参照"権限の場合
        } else if (targetAuthority === AUTHORITY_VIEW) {
            functionDivAuthorityInfo.authorityInfo
                .filter(functionDivAuthority => {
                    const authorityId = Number(functionDivAuthority.authority)
                    return authorityId === AUTHORITY_POST_COMMENT
                })
                .forEach(functionDivAuthority => {
                    const linkAuthorityInfo =
                        functionDivAuthority.roleAuthorityInfo[roleAuthorityIndex]
                    // 参照権限を無効にする時には対象権限も連動して無効にする
                    if (setValidFlag === VALID_OR_NOT_CHECK.NOT.value) {
                        linkAuthorityInfo.validFlag = VALID_OR_NOT_CHECK.NOT.value
                    }
                })
        }

        // 変更対象の機能分類
        const targetFunctionDivAuthority: number = Number(functionDivAuthorityInfo.functionDivId)
        // 変更対象が"設備/施設設定"機能の場合


        if (useWebsite === AVAILABLE_SITE.ADMIN.value) {
            if (targetFunctionDivAuthority === FUNCTION_DIV_ID_FACILITY_SETTING) {
                // 更新対象が"設備/施設設定"機能の場合
                this.updateLinkFunctionDivAuthoritySetting(
                    FUNCTION_DIV_ID_FACILITY_SETTING,
                    FUNCTION_DIV_ID_FACILITY_DESCRIPTION,
                    targetAuthority,
                    authorityInfo.roleAuthorityInfo[roleAuthorityIndex].roleId,
                )
            } else if (targetFunctionDivAuthority === FUNCTION_DIV_ID_FACILITY_DESCRIPTION) {
                // 更新対象が"施設説明"機能の場合
                this.updateLinkFunctionDivAuthoritySetting(
                    FUNCTION_DIV_ID_FACILITY_DESCRIPTION,
                    FUNCTION_DIV_ID_FACILITY_SETTING,
                    targetAuthority,
                    authorityInfo.roleAuthorityInfo[roleAuthorityIndex].roleId,
                )
            } else if (targetFunctionDivAuthority === FUNCTION_DIV_ID_CLOSED_SETTING) {
                this.updateRelatedAuthorityByClosedSetting(
                    targetAuthority,
                    functionDivAuthorityInfo,
                    setValidFlag,
                    roleAuthorityIndex,
                    targetFunctionDivAuthority,
                )
            }
            this.setState({adminAuthoritySetting: authoritySetting})
        } else {
            authoritySetting = this.state.residentAuthoritySetting
            this.setState({residentAuthoritySetting: authoritySetting})
        }
    }

    updateRelatedAuthorityByClosedSetting(
        targetAuthority: number,
        functionDivAuthorityInfo: FunctionDivAuthorityInfo,
        setValidFlag: string,
        roleAuthorityIndex: number,
        targetFunctionDivAuthority: number,
    ): void {

        if (targetAuthority === AUTHORITY_VIEW || targetAuthority === AUTHORITY_EDIT) {
            const cancelReservationAuthorityInfo = functionDivAuthorityInfo.authorityInfo
                .find(info => Number(info.authority) === AUTHORITY_CANCEL_RESERVATION)

            if (setValidFlag === VALID_OR_NOT_CHECK.NOT.value && cancelReservationAuthorityInfo !== undefined) {
                cancelReservationAuthorityInfo.roleAuthorityInfo[roleAuthorityIndex].validFlag =
                    VALID_OR_NOT_CHECK.NOT.value
            }
        } else if (
            targetFunctionDivAuthority === FUNCTION_DIV_ID_CLOSED_SETTING &&
            targetAuthority === AUTHORITY_CANCEL_RESERVATION
        ) {
            const viewAuthorityInfo = functionDivAuthorityInfo.authorityInfo
                .find(info => Number(info.authority) === AUTHORITY_VIEW)
            const editAuthorityInfo = functionDivAuthorityInfo.authorityInfo
                .find(info => Number(info.authority) === AUTHORITY_EDIT)

            if (setValidFlag === VALID_OR_NOT_CHECK.VALID.value) {
                if (viewAuthorityInfo !== undefined) {
                    viewAuthorityInfo.roleAuthorityInfo[roleAuthorityIndex].validFlag =
                        VALID_OR_NOT_CHECK.VALID.value
                }
                if (editAuthorityInfo !== undefined) {
                    editAuthorityInfo.roleAuthorityInfo[roleAuthorityIndex].validFlag =
                        VALID_OR_NOT_CHECK.VALID.value
                }
            }
        }
    }

// 有効/無効　更新（機能連動）
    updateLinkFunctionDivAuthoritySetting(
        fromFunctionDivId: number,
        toFunctionDivId: number,
        targetAuthority: number,
        targetRoleId: string,
    ): void {
        const {adminAuthoritySetting} = this.state

        // 連動元の参照・編集権限と対象ロールに対するチェック状況を取得
        const fromRoleAuthorityViewInfo: RoleAuthorityInfo = adminAuthoritySetting.functionDivAuthorityInfo.filter(
            functionDivAuthority => Number(functionDivAuthority.functionDivId) === fromFunctionDivId)[0]
            .authorityInfo.filter(authority => Number(authority.authority) === AUTHORITY_VIEW)[0]
            .roleAuthorityInfo.filter(roleAuthority => roleAuthority.roleId === targetRoleId)[0]
        const fromRoleAuthorityEditInfo: RoleAuthorityInfo = adminAuthoritySetting.functionDivAuthorityInfo.filter(
            functionDivAuthority => Number(functionDivAuthority.functionDivId) === fromFunctionDivId)[0]
            .authorityInfo.filter(authority => Number(authority.authority) === AUTHORITY_EDIT)[0]
            .roleAuthorityInfo.filter(roleAuthority => roleAuthority.roleId === targetRoleId)[0]

        if (fromFunctionDivId === FUNCTION_DIV_ID_FACILITY_DESCRIPTION && targetAuthority === AUTHORITY_VIEW &&
            fromRoleAuthorityViewInfo.validFlag === VALID_OR_NOT_CHECK.VALID.value) {
            // 連動元 = 施設説明　かつ　操作権限 = 参照権限 かつ　参照権限を付けた場合、なにもしない
            return
        } else if (fromFunctionDivId === FUNCTION_DIV_ID_FACILITY_DESCRIPTION && targetAuthority === AUTHORITY_EDIT) {
            // 連動元 = 施設説明　かつ　操作権限 = 編集権限の場合、なにもしない
            return
        }

        const toRoleAuthorityViewInfo: RoleAuthorityInfo = adminAuthoritySetting.functionDivAuthorityInfo.filter(
            functionDivAuthority => Number(functionDivAuthority.functionDivId) === toFunctionDivId)[0]
            .authorityInfo.filter(t => Number(t.authority) === AUTHORITY_VIEW)[0]
            .roleAuthorityInfo.filter(b => b.roleId === targetRoleId)[0]
        const toRoleAuthorityEditInfo: RoleAuthorityInfo = adminAuthoritySetting.functionDivAuthorityInfo.filter(
            functionDivAuthority => Number(functionDivAuthority.functionDivId) === toFunctionDivId)[0]
            .authorityInfo.filter(t => Number(t.authority) === AUTHORITY_EDIT)[0]
            .roleAuthorityInfo.filter(b => b.roleId === targetRoleId)[0]

        // 連動元から連動先へ参照権限のチェック状況をコピー
        if (targetAuthority === AUTHORITY_VIEW ||
            (targetAuthority === AUTHORITY_EDIT &&
                fromRoleAuthorityEditInfo.validFlag === VALID_OR_NOT_CHECK.VALID.value)) {
            // 操作権限 = 参照権限 または、操作権限 = 編集権限で、チェックを付けた場合
            toRoleAuthorityViewInfo.validFlag = fromRoleAuthorityViewInfo.validFlag
        }

        // 連動元から連動先へ編集権限のチェック状況をコピー
        if (targetAuthority === AUTHORITY_EDIT ||
            (targetAuthority === AUTHORITY_VIEW &&
                fromRoleAuthorityViewInfo.validFlag === VALID_OR_NOT_CHECK.NOT.value)) {
            // 操作権限 = 編集権限 または、操作権限 = 参照権限で、チェックを外した場合
            toRoleAuthorityEditInfo.validFlag = fromRoleAuthorityEditInfo.validFlag
        }
    }

    // 変更検知
    judgeAuthoritySetting(
        useWebsite: string,
        functionDivAuthorityIndex: number,
        authorityIndex: number,
        roleAuthorityIndex: number): boolean {

        let authoritySetting: UseWebsite
        let originAuthoritySetting: UseWebsite
        if (useWebsite === AVAILABLE_SITE.ADMIN.value) {
            authoritySetting = this.state.adminAuthoritySetting
            originAuthoritySetting = this.originAdminAuthoritySetting
        } else {
            authoritySetting = this.state.residentAuthoritySetting
            originAuthoritySetting = this.originResidentAuthoritySetting
        }

        const functionDivAuthorityInfo: FunctionDivAuthorityInfo =
            authoritySetting.functionDivAuthorityInfo[functionDivAuthorityIndex]
        const authorityInfo: AuthorityInfo = functionDivAuthorityInfo.authorityInfo[authorityIndex]
        const roleAuthorityInfo: RoleAuthorityInfo = authorityInfo.roleAuthorityInfo[roleAuthorityIndex]

        const originFunctionDivAuthorityInfo: FunctionDivAuthorityInfo =
            originAuthoritySetting.functionDivAuthorityInfo[functionDivAuthorityIndex]
        const originAuthorityInfo: AuthorityInfo = originFunctionDivAuthorityInfo.authorityInfo[authorityIndex]
        const originRoleAuthorityInfo: RoleAuthorityInfo = originAuthorityInfo.roleAuthorityInfo[roleAuthorityIndex]

        if (roleAuthorityInfo && originRoleAuthorityInfo) {
            const validFlag: string = roleAuthorityInfo.validFlag
            const originValidFlag: string = originRoleAuthorityInfo.validFlag
            return validFlag !== originValidFlag
        }
        return false
    }

    registerAuthoritySettingButton(): void {
        this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0010.errorLevel,
                message: Messages.IOPCC0010.toString('権限'),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleRegisterCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleRegisterOkClick,
                    },
                ],
            },
        )
    }

    async handleRegisterOkClick(): Promise<void> {
        const condominiumAuthoritySettingInfo: CondominiumAuthoritySettingInfo[] = []
        const adminAuthoritySetting: UseWebsite = this.state.adminAuthoritySetting
        const residentAuthoritySetting: UseWebsite = this.state.residentAuthoritySetting

        const originFacilityClosedSettingInfo: UseWebsite = this.originAdminAuthoritySetting
        const originResidentAuthoritySetting: UseWebsite = this.originResidentAuthoritySetting

        // 更新対象設定
        this.createCondominiumAuthoritySettingInfo(
            adminAuthoritySetting,
            originFacilityClosedSettingInfo,
            condominiumAuthoritySettingInfo)
        this.createCondominiumAuthoritySettingInfo(
            residentAuthoritySetting,
            originResidentAuthoritySetting,
            condominiumAuthoritySettingInfo)

        this.props.eventEmitter.closeDialog()

        await this.props.eventEmitter.showLoading()
        try {
            const requestParams: NatPutCondominiumAuthoritySettingParams = {
                condominiumCd: this.props.condominiumCd,
                condominiumAuthoritySettingInfo: condominiumAuthoritySettingInfo,
            }
            const condominiumAuthoritySettingResponse: Nullable<NatPutCondominiumAuthoritySetting> =
                await this.props.asyncCallFunction(
                    this.props.condominiumAuthoritySettingRepo.putCondominiumAuthoritySetting.bind(
                        this.props.condominiumAuthoritySettingRepo, requestParams),
                    (httpErrorOrNetworkError) => {
                        httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.EOPCA0002.toString('権限')},
                )

            if (condominiumAuthoritySettingResponse && condominiumAuthoritySettingResponse.requestError === null) {
                this.props.navigate(
                    `/admin/condominium/${this.props.condominiumCd}`,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IOPCC0008.toString('権限'),
                            },
                        },
                    },
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    // 更新対象設定
    createCondominiumAuthoritySettingInfo(
        authoritySetting: UseWebsite,
        originAuthoritySetting: UseWebsite,
        condominiumAuthoritySettingInfo: CondominiumAuthoritySettingInfo[],
    ): void {
        authoritySetting.functionDivAuthorityInfo.some((functionDivAuthority, functionDivAuthorityIndex) => {
            const jsonFunctionDivAuthority: string =
                JSON.stringify(authoritySetting.functionDivAuthorityInfo[functionDivAuthorityIndex])
            const jsonOriginFunctionDivAuthority: string =
                JSON.stringify(originAuthoritySetting.functionDivAuthorityInfo[functionDivAuthorityIndex])
            // "物件権限設定"に差異が存在しない場合、更新対象外
            if (jsonFunctionDivAuthority === jsonOriginFunctionDivAuthority) {
                return
            }
            const functionDivId: string = functionDivAuthority.functionDivId
            functionDivAuthority.authorityInfo.some((authorityInfo, authorityInfoIndex) => {
                const authority: string = authorityInfo.authority
                authorityInfo.roleAuthorityInfo.some((roleAuthorityInfo, roleAuthorityInfoIndex) => {
                    const jsonRoleAuthorityInfo: string =
                        JSON.stringify(authoritySetting.functionDivAuthorityInfo
                            [functionDivAuthorityIndex].authorityInfo
                            [authorityInfoIndex].roleAuthorityInfo[roleAuthorityInfoIndex])
                    const jsonOriginRoleAuthorityInfo: string =
                        JSON.stringify(originAuthoritySetting.functionDivAuthorityInfo
                            [functionDivAuthorityIndex].authorityInfo
                            [authorityInfoIndex].roleAuthorityInfo[roleAuthorityInfoIndex])
                    // "ロール別権限設定"に差異が存在しない場合、更新対象外
                    if (jsonRoleAuthorityInfo === jsonOriginRoleAuthorityInfo) {
                        return
                    }
                    // 更新情報を、配列に追加
                    condominiumAuthoritySettingInfo.push({
                        functionDivId: functionDivId,
                        authority: authority,
                        roleId: roleAuthorityInfo.roleId,
                        validFlag: roleAuthorityInfo.validFlag,
                        version: roleAuthorityInfo.version,
                    })
                })
            })
        })
    }

    handleRegisterCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    cancelLinkClick(): void {
        this.props.navigate(
            `/admin/condominium/` + this.props.condominiumCd,
        )
    }

    renderPageFooterArea(): ReactNode {
        return (
            <>
                <PageFotterAreaRight>
                    <AdminPrimaryButton onClick={this.registerAuthoritySettingButton}>
                        登録
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink onClick={this.cancelLinkClick}>
                        キャンセル
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    renderPage(): ReactElement {
        return (
            <>
                <PageMainArea>
                    {this.renderAuthoritySettingTable(this.state.adminAuthoritySetting)}
                    <Box mt={'30px'}>
                        {this.renderAuthoritySettingTable(this.state.residentAuthoritySetting)}
                    </Box>
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>
        )
    }

    render(): ReactNode {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                {this.renderPage()}
            </>
        )
    }
}

export default createAdminPage(NatAdminCondominiumAuthoritySettingPage)

const StyledTableCell = styled(({changeFlg, ...props}) => (
    <TableCell {...props} />
))<TableCellProps & { changeFlg?: boolean }>`
  ${props => props.changeFlg === true ? `
     background-color:#ffe0b2;
  ` : ``};
  cursor: pointer;
`

const NonEditTableCell = styled(TableCell)`
  background-color: rgba(0, 0, 0, 0.12);
`

const FlexTableHeaderContainer = styled.div`
  display: flex;
  color: inherit;
  outline: 0;
  vertical-align: middle;
  width: 100%;
`

const FlexTableHeaderItem = styled.div`
  flex: 1 0 auto;
  background-color: #fafafa;
  text-align: center;
  padding: 14px 12px 14px 12px;
  border-bottom: 1px solid rgba(224, 224, 224, 1);
`

const FlexTableHeaderNotGrowItem = styled(FlexTableHeaderItem)`
  flex: 0 0 auto;
`
